module.exports = __webpack_public_path__ + "img/category-chromatography.bc98c0c3.png";